import type { InsurancePolicyModel } from "@/api/cle-api";

import { DetailItem } from "../person/id/Efteruddannelse/DetailItem";
import { StatusBadge } from "../person/id/Efteruddannelse/StatusBadge";
import {
  formatEvidenceStatus,
  getEvidenceStatusVariant,
} from "../person/id/Efteruddannelse/utils/evidenceStatus";
import { formatDateLong } from "../person/id/Efteruddannelse/utils/formatters";
import { formatAiDecision } from "../person/id/Efteruddannelse/utils/aiDecision";

interface InsurancePolicyInformationProps {
  policy: InsurancePolicyModel;
}

export const InsurancePolicyInformation = ({
  policy,
}: InsurancePolicyInformationProps) => (
  <div className="c-card c-item-list">
    <h3 className="flex-100">Information</h3>
    <DetailItem label="Filnavn" value={policy.fileName ?? "-"} />
    <DetailItem label="Type" value="Forsikringspolice" />
    <DetailItem
      label="Status"
      value={
        <StatusBadge
          pill
          status={formatEvidenceStatus(policy.status)}
          variant={getEvidenceStatusVariant(policy.status)}
        />
      }
    />
    <DetailItem
      label="AI-vurdering"
      value={formatAiDecision(policy.aiDecision)}
    />
    <DetailItem label="Oprettet" value={formatDateLong(policy.createdAt)} />
    <DetailItem label="Oprettet af" value={policy.createdByUserName ?? "-"} />
  </div>
);
